/* eslint-disable @typescript-eslint/no-unused-vars */
import { useState } from 'react';
import { Col, Row } from 'react-bootstrap';

import { Link } from 'react-router-dom';
import { inject, observer } from 'mobx-react';
import DataTable from '../core/components/datatable/DataTable';
import { useComponentDidMount } from '../core/hooks';
import { unixToDateTimeString } from '../core/utils/date';
import {
  clientActions,
  ClientStore,
} from 'modules/clients/store/clientStore';
import { urlSelector } from 'lib/functions';
import moment from 'moment';

interface ClientFCMTokensProps {
  clientId: string,
  clientStore?: ClientStore,
}

const ClientFCMTokens = (props: ClientFCMTokensProps) => {
  const {
    clientStore,
    clientId,
  } = props;

  const { clientFCMTokensByClientId, clientFCMTokensList } = clientStore;

  const [loading, setLoading] = useState(false);
  
  // function formatDateTime(dateString) {
  //   if (!dateString || typeof dateString !== 'string') {
  //     return '';
  //   }  
  //   try {
  //     const date = moment(dateString);    
  //     if (!date.isValid()) {
  //       return '';
  //     }
  //     return date.format('YYYY-MM-DD HH:mm:ss');    
  //   } catch {
  //     return '';
  //   }
  // }

  const columns = [
    // { title: 'Дата, время заявки', name: 'createdAt', getCellValue: (row, cell) => unixToDateTimeString(row[cell]) },
    // { title: 'Токен', name: 'token' },
    { title: 'Устройство', name: 'tokenTypeRefValueName' },
    { title: 'Регистрация', name: 'createdDate', width: 250, getCellValue: (row, cell) => unixToDateTimeString(row[cell]) },
    { title: 'Последняя активность', name: 'lastDate', width: 250, getCellValue: (row, cell) => unixToDateTimeString(row[cell]) },
  ];

  const loadData = async (request:string) => {
    setLoading(true);
    clientActions.getClientFCMTokensList(request);
    setLoading(false);
  };

  useComponentDidMount(() => {
    if (clientFCMTokensByClientId !== clientId) { loadData(clientId); }
  });

  return (
    <Col md={ 12 }>
      <Row>
        { (clientFCMTokensByClientId === clientId)
        && (
          <Col md={ 12 }>
            <DataTable
              loading={ loading }
              data={ clientFCMTokensList || [] }
              columns={ columns }
              localPaging
              localSorting
              hideToolbar
            />
          </Col>
        ) }
      </Row>
    </Col>
  );
};

export default inject('clientStore')(observer(ClientFCMTokens));
